const { CUSTOM_YTM_ID, ORIGIN_PH, YA_GEN_VPN } = process.env;

const YTM_ADDITIONAL_CODE = '';

/**
 * Счетчики Яндекс.Метрики
 */
const ytm = () => `<script type="text/javascript">
    (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
    })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${CUSTOM_YTM_ID}', 'ym');
    ym(${CUSTOM_YTM_ID}, 'init', {ssr:true, webvisor:true, ecommerce:"dataLayer", referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true});
</script>`;

const ytmNoScript = `<noscript><div><img src="https://mc.yandex.ru/watch/${CUSTOM_YTM_ID}" style="position:absolute; left:-9999px;" alt="" /></div></noscript>`;

const ytmCookie = `<script type="text/javascript">
    function setCookie(name, value, days){
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000)); 
        var expires = "; expires=" + date.toGMTString();
        document.cookie = name + "=" + value + expires + ";path=/";
    }
    function getParam(p){
        var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\\+/g, ' '));
    }
    var yclid = getParam('yclid');
    if(yclid){
        setCookie('yclid', yclid, 90);
    }
</script>`;

const ytmSendUserParams = `
    <script>
     (function () {
        function readCookie(name) { 
          var n = name + "="; 
          var cookie = document.cookie.split(';'); 
          for(var i=0;i < cookie.length;i++) {      
              var c = cookie[i];      
              while (c.charAt(0)==' '){c = c.substring(1,c.length);}      
              if (c.indexOf(n) == 0){return c.substring(n.length,c.length);} 
          } 
          return null; 
          }

        function send (platformId) {
          var yid = readCookie('_ym_uid');
          var time = new Date().getTime();
          var ycl_id = readCookie('yclid');

          //параметры визита и параметры пользователя
          ym(${CUSTOM_YTM_ID}, 'params', {
            SessionID_YM: time + "." + yid,
            platformId: platformId,
            yclid: ycl_id,
            ClientID_YM: yid
          });

          ${YTM_ADDITIONAL_CODE}
        }
        // Логика ожидания
        var pid = readCookie('platformId');
        if (pid) {
          send(pid);
        } else {
          window.addEventListener(
            'platformIdReady',
            function handler (e) {
              window.removeEventListener('platformIdReady', handler);
              send(e.detail);
            },
            { once: true }
          );
        }
      })()
    </script>
`;

const clearView = `
    <script>
    (function () {
        var csUrl = '${YA_GEN_VPN}';
        
        if (!csUrl || csUrl.trim() === '' || csUrl === 'undefined') {
            return;
        }
        
        var clientId = null;
        var isCompleted = false;
        var isSent = false;
        
        function sendBeaconRequest() {
            if (isSent) return;
            isSent = true;

            navigator.sendBeacon('${YA_GEN_VPN}', {});
        }
        
        function completeCheck() {
            if (isCompleted) return;
            isCompleted = true;
            
            if (clientId && clientId.trim() !== '') {
                return;
            }
            
            sendBeaconRequest();
        }
        
        try {
        if (window.location.pathname == '/'){
        ym(${CUSTOM_YTM_ID}, 'getClientID', function(clientID) {
                clientId = clientID;
                completeCheck();
            });
        }
            
        } catch (e) {
            sendBeaconRequest();
        }
        setTimeout(completeCheck, 3000);
        
    })()
    </script>
`;

const ytmSendEvent = webAnalytics => `<script>
   var product = ${webAnalytics.product ? `'${webAnalytics.product}'` : 'undefined'};
   var productDetail = ${webAnalytics.productDetail ? `'${webAnalytics.productDetail}'` : 'undefined'};
   var pagetype = ${webAnalytics.pageType ? `'${webAnalytics.pageType}'` : 'undefined'};
   var path = ${webAnalytics.path ? `'${webAnalytics.path}'` : 'undefined'};
   ${
       webAnalytics.product && webAnalytics.pageType && webAnalytics.path
           ? `
     window.dataLayer.push({
        path,
        pagetype,
        product,
        ${webAnalytics.productDetail ? `'product_detail': productDetail,` : ''}
        event: 'gtm_push_params',
     });
   `
           : ''
   }
   function ytmSendEvent(dlvalues){  
      product = dlvalues.product || product || '';
      productDetail = dlvalues.product_detail || productDetail || '';
      pagetype = dlvalues.pagetype || pagetype || '';
      path = path || dlvalues.path || '';
      var action = dlvalues.action || '';
      var block = dlvalues.block || '';
      var labelDetail = dlvalues.label_detail || '';
      var event = dlvalues.event || '';   
      var newProductDetail = productDetail && productDetail != 'undefined' ? '::'+ productDetail : ''
      var eventCategory = dlvalues.eventCategory || product+newProductDetail;
      var dimension_40 = dlvalues.dimension_40 || '';
      var eventAction = dlvalues.eventAction || pagetype + '::' + block + '::' + action + '::' + dimension_40;
      var eventLabel = dlvalues.eventLabel || labelDetail+'::'+path;
      if (eventCategory && (event == 'gtm_interaction_event' || event == 'gtm_non_interaction_event')){
         ym(${CUSTOM_YTM_ID}, 'params', { 'event': { [eventCategory]: { [eventAction]: eventLabel }}});
      }
   }
   if (window.DATA_LAYER) { window.DATA_LAYER.subscribe(ytmSendEvent) }
</script>`;

module.exports = {
    YTM_ADDITIONAL_CODE,
    ytm,
    ytmNoScript,
    ytmCookie,
    ytmSendUserParams,
    ytmSendEvent,
    clearView
};
